export default {
  common: {
    language: "Мова",
    logout: "Вийти",
    yes: "Так",
    no: "Ні"
  },
  languages: {
    uk: "Українська",
    ru: "Русский",
    en: "English"
  },
  notifications: {
    error: "Помилка",
    loginError: "Помилка входу",
    restoreError: "Помилка відновлення",
    changePasswordError: "Помилка зміни пароля"
  },
  auth: {
    login: {
      title: "Вхід до системи",
      subtitle: "Увійдіть, щоб отримати доступ",
      passwordPlaceholder: "Пароль",
      submit: "Увійти",
      forgotPassword: "Забули пароль?",
      noAccountTitle: "Немає акаунта?",
      noAccountDesc: "Зареєструйтеся зараз, щоб мати доступ до функцій системи",
      register: "Зареєструватися"
    },
    restore: {
      title: "Відновлення пароля",
      subtitle: "Введіть пошту, на яку зареєстрований акаунт",
      emailNotFound: "Цей email не існує в системі.",
      submit: "Відновити",
      sentMessagePrefix: "На вказану адресу",
      sentMessageSuffix:
        "було відправлено лист із подальшими інструкціями з відновлення пароля"
    },
    changePassword: {
      title: "Зміна пароля",
      oldPasswordPlaceholder: "Введіть старий пароль",
      newPasswordPlaceholder: "Придумайте новий пароль",
      confirmPasswordPlaceholder: "Підтвердіть новий пароль",
      weakPassword:
        "Пароль занадто слабкий. Він має містити щонайменше одну велику латинську літеру, одну цифру та мати довжину від 6 символів.",
      passwordsMismatch: "Паролі не збігаються.",
      submit: "Змінити"
    }
  },
  register: {
    title: "Реєстрація на гру",
    subtitle: "Уважно заповніть усі поля",
    callsignLabel: "Ігрове ім'я*",
    callsignPlaceholder: "Позивний",
    cyrillicHint: "Тільки кирилиця!",
    requiredField: "Це обов'язкове поле.",
    callsignMinLength: "Позивний має містити щонайменше {min} літери.",
    callsignNotUnique: "Такий позивний уже зайнятий.",
    passportPhotoLabel: "Фото на паспорт*",
    uploadButton: "Завантажити",
    passportPhotoHint:
      "Потрібно вибрати й акуратно обрізати фото, оскільки воно буде розміщено у вашому ігровому паспорті.",
    legendLabel: "Квента персонажа*",
    legendPlaceholder: "Опишіть історію вашого персонажа",
    legendHint:
      "Без квенти заявки не приймаються. Максимальна довжина - 1800 символів.",
    legendMinLength: "Квента має містити щонайменше {min} символів.",
    legendMaxLength:
      "Квента має містити не більше {max} символів. Будь ласка, трохи скоротіть текст.",
    contraindicationsLabel: "Протипоказання",
    contraindicationsPlaceholder:
      "Вкажіть ваші медичні або інші протипоказання (за наявності)",
    photosLabel: "Кілька фото в екіпіруванні*",
    photosDragText: "Перетягніть фото",
    photosBrowseText: "або натисніть сюди",
    photosPopupText: "завантажте зображення",
    photosDropText: "Відпустіть тут",
    photosHint:
      "Додавайте ВЛАСНІ фото для проходження дрес-коду. Кожне фото має бути розміром до 1МБ.",
    agreementTitle: "Погодження",
    agreementRulesPrefix: "Я даю згоду і зобов'язуюсь виконувати",
    agreementRulesLink: "правила",
    agreementRulesSuffix: "проведення заходу",
    agreementData:
      "Я даю згоду за власною волею і в своєму інтересі на зберігання, обробку й використання наданих мною персональних даних",
    submit: "Зареєструватися",
    imageTooBig: "Зображення перевищує допустимий розмір 1МБ",
    errorTitle: "Помилка реєстрації",
    email: {
      label: "E-mail*",
      placeholder: "Email",
      hint: "напр. w.degtyarev@gmail.com",
      invalid: "Введене значення некоректне.",
      invalidFormat: "Невірний формат адреси електронної пошти.",
      notUnique: "Цей email уже зайнятий.",
      tryLoginPrefix: "Спробуйте",
      tryLoginAction: "увійти",
      tryLoginSuffix: "у систему."
    },
    fullName: {
      label: "Прізвище*, Ім'я*, По батькові",
      lastNamePlaceholder: "Прізвище",
      firstNamePlaceholder: "Ім'я",
      fatherNamePlaceholder: "По батькові",
      firstNameRequired: "Ім'я є обов'язковим полем.",
      firstNameMin: "Ім'я має містити щонайменше {min} літери.",
      lastNameRequired: "Прізвище є обов'язковим полем.",
      lastNameMin: "Прізвище має містити щонайменше {min} літери."
    },
    password: {
      label: "Пароль*",
      placeholder: "Придумайте пароль",
      confirmPlaceholder: "Підтвердіть пароль",
      weak:
        "Пароль занадто слабкий. Він має містити щонайменше одну велику латинську літеру, одну цифру та мати довжину від 6 символів.",
      mismatch: "Паролі не збігаються."
    },
    phone: {
      label: "Контактний телефон*",
      placeholder: "+38 (999) 999-9999",
      hint: "напр. +38 (999) 999-9999"
    },
    birthday: {
      label: "Дата народження*",
      hint: "напр. 26.04.1986"
    },
    city: {
      label: "Місто*",
      noOptions: "Почніть вводити для пошуку...",
      noResult: "Нічого не знайдено, спробуйте інший запит",
      hint: "Місто, з якого будете діставатися"
    },
    team: {
      label: "Команда*",
      placeholder: "Введіть назву своєї команди, якщо не знайшли у списку",
      hint:
        "Вкажіть свою страйкбольну команду або Внеком. Можна обрати зі списку або ввести нову."
    },
    fractions: {
      label: "Угруповання*",
      placesLeft: "місць"
    },
    suit: {
      label: "Костюм*",
      placeholder: "Виберіть костюм"
    },
    forbidden: {
      title: "Реєстрація на гру закрита",
      subtitle: "Дякуємо, місць більше немає"
    },
    success: {
      title: "Дякуємо за заявку!",
      textPrefix: "Після її розгляду на пошту",
      textSuffix: "надійде лист із подальшими інструкціями",
      loginPrefix: "Ви можете",
      loginLink: "Увійти в Систему",
      loginSuffix: "за вказаними вами даними (email і пароль)"
    }
  },
  scan: {
    scanAnother: "Сканувати іншого",
    errorTitle: "Помилка сканування"
  },
  components: {
    common: {
      none: "Немає",
      nothing: "Нічого",
      rub: "куп."
    },
    grid: {
      actions: "Дії",
      action: "Дія",
      total: "Всього записів"
    },
    memberData: {
      code: "Код",
      callsign: "Позивний",
      fraction: "Угруповання",
      suit: "Костюм",
      legend: "Легенда",
      rank: "Ранг",
      experience: "Досвід",
      money: "Гроші",
      createdAt: "Створено",
      passportPhoto: "Фото на паспорт",
      lookPhoto: "Фото на допуск",
      profilePhotos: "Фото профіля",
      passport: "Паспорт",
      passportFront: "лицьова сторона",
      passportBack: "тильна сторона",
      passportQr: "QR-код",
      generatePassport: "Згенерувати паспорт",
      regeneratePassport: "Перегенерувати паспорт",
      legendTitle: "Легенда сталкера {callsign}",
      fractionTitle: "Опис угруповання {title}",
      suitTitle: "Опис костюма {title}"
    },
    memberRequest: {
      closed: "Реєстрація на {title} закрита",
      hasPassport: "Наявність ігрового паспорта",
      passportYes: "В наявності",
      passportLost: "Втрачений"
    },
    regPending: {
      pending: "Що видати"
    },
    userData: {
      fullName: "ПІБ",
      phone: "Телефон",
      bornAt: "Дата народження",
      city: "Місто",
      team: "Команда",
      contraindications: "Протипоказання"
    },
    notifications: {
      whatChanged: "Що змінилося",
      legendDiffTitle: "Подробиці змін у легенді",
      before: "До",
      after: "Після"
    },
    gpsAdd: {
      hint:
        "Тут можна встановити вашу поточну GPS-позицію як координати об'єкта",
      unavailable: "Геолокація недоступна",
      addMark: "Додати мітку"
    }
  },
  member: {
    character: {
      back: "Назад",
      createLimitNote:
        "Зверніть увагу: максимальна кількість ваших персонажів - 3.",
      createActiveNote:
        "Новий персонаж стане активним для подачі на гру. Обирайте мудро.",
      passportPhotoLabelEdit: "Фото на паспорт",
      uploadNew: "Завантажити нове",
      passportLocked:
        "Редагування фото на паспорт неможливе, оскільки у вас вже є паспорт.",
      suitLabelEdit: "Костюм",
      suitLocked:
        "Зміна костюма недоступна, оскільки у вас вже є підтверджена заявка на найближчий захід.",
      legendLabelEdit: "Квента персонажа",
      legendLocked:
        "Зміна квенти недоступна, оскільки у вас вже є підтверджена заявка на найближчий захід.",
      photosLabelEdit: "Кілька фото в екіпіруванні",
      photosLocked:
        "Зміна фотографій на допуск недоступна, оскільки у вас вже є підтверджена заявка на найближчий захід.",
      saveChanges: "Зберегти зміни",
      saved: "Дані збережено"
    },
    profile: {
      addCharacter: "Додати персонажа",
      createBlocked:
        "Створення нового персонажа недоступне, оскільки у вас вже є підтверджена заявка на найближчий захід"
    },
    members: {
      callsign: "Позивний:",
      suit: "Костюм:",
      rank: "Ранг:"
    },
    events: {
      noActive: "Поки немає доступних заходів",
      dates: "Дати проведення",
      feeBefore: "Внесок до {date}",
      yourFeeBefore: "Ваш внесок до {date}",
      feeAfter: "Внесок після {date}",
      yourFeeAfter: "Ваш внесок після {date}",
      feeAfterReg: "Внесок після {date}",
      yourFeeAfterReg: "Ваш внесок після {date}",
      regClosing: "закриття реєстрації",
      history: "Історія",
      participants: "Учасники",
      showParticipants: "Показати {count} учасників",
      requests: "Заявки",
      requestStatus: "Статус заявки:",
      organizerComment: "Коментар організатора",
      submitRequest: "Подати заявку",
      fractionFull: "На жаль, ваша група вже заповнена",
      historyTitle: "Історія заходу: {title}",
      requestTitle: "Заявка на захід: {title}"
    }
  },
  admin: {
    edit: {
      back: "Назад",
      save: "Зберегти"
    },
    common: {
      refresh: "Оновити",
      userDataTitle: "Дані користувача",
      memberDataTitle: "Дані гравця"
    },
    members: {
      income: "Дохід",
      cols: {
        city: "Місто",
        callsign: "Позивний",
        lastName: "Прізвище",
        firstName: "Ім'я",
        fraction: "Угруповання",
        paid: "Сплачено",
        paymentType: "Тип оплати",
        requestDate: "Дата заявки"
      }
    },
    registration: {
      pendingDataTitle: "Дані про видачу",
      cols: {
        suit: "Костюм",
        rank: "Ранг",
        experience: "Досвід",
        money: "Гроші",
        pending: "До видачі"
      },
      moneyValue: "{value} куп.",
      pendingCount: "{count} предмет(ів)",
      pendingEmpty: "Нічого"
    },
    notifications: {
      newCount: "Нових сповіщень: {count}",
      view: "Переглянути",
      changeTitle: "Перегляд зміни",
      processSuccess: "Зміну позначено як прочитану",
      cols: {
        type: "Тип зміни",
        readBy: "Ким прочитано",
        updatedAt: "Дата зміни"
      }
    },
    requests: {
      organizerCommentTitle: "Коментар організатора",
      confirmModalTitle: "Підтвердження заявки від {who}",
      commentModalTitle: "Коментар до заявки від {who}",
      rejectModalTitle: "Відхилення заявки від {who}",
      payModalTitle: "Оплата реєстрації від {who}",
      feeDiscount: "Внесок з тимчасовою знижкою",
      feeNoDiscount: "Внесок без тимчасової знижки",
      feeAfterClose: "Внесок після закриття реєстрації",
      addComment: "Додати коментар",
      comment: "Коментар",
      confirmCommentPlaceholder:
        "Додайте коментар до листа з підтвердженням заявки (необов'язково)",
      commentPlaceholder: "Додайте коментар до листа",
      howMuchPaid: "Скільки сплатив?",
      paidDescription: "(сумарно, якщо була оплата частинами)",
      notPaid: "не платив",
      paymentType: "Тип оплати",
      forceFullDescription:
        "(увімкнути, якщо потрібно відмітити повну оплату, коли не вся сума була сплачена)",
      forceFullPayment: "Форсувати повний платіж",
      free: "безкоштовно",
      currency: "грн",
      descToDate: "* скільки гравець має сплатити до {date}",
      descAfterDate: "* скільки гравець має сплатити після {date}",
      descAfterReg:
        "* скільки гравець має сплатити після {date} (закриття реєстрації)",
      cols: {
        passport: "Паспорт?",
        fee: "Внесок",
        discountFee: "Зі знижкою",
        updated: "Змінено",
        legendOk: "Квента ОК?",
        lookOk: '"Антураж" ОК?',
        status: "Статус"
      },
      actions: {
        lookApprove: 'Схвалити "антураж"',
        legendApprove: "Схвалити квенту",
        approve: "Підтвердити",
        comment: "Коментувати",
        reject: "Відхилити",
        payed: "Оплатив"
      }
    },
    firmwareAdd: {
      nameLabel: "Назва прошивки",
      fileLabel: "Бінарний файл прошивки",
      typeLabel: "Тип прошивки",
      descLabel: "Опис",
      descPlaceholder: "Додайте опис до прошивки (необов'язково)",
      tagLabel: "Тег",
      currentLabel: "Поточна?",
      currentDesc: "Така прошивка стане поточною",
      add: "Додати",
      savedTitle: "Прошивку додано",
      savedBody: 'Версія прошивки "{title}" (ID = {id}):'
    },
    firmwaresList: {
      add: "Додати",
      cols: {
        type: "Тип",
        tag: "Тег",
        version: "Версія",
        current: "Поточна?",
        file: "Файл",
        createdAt: "Дата створення"
      }
    },
    itemsList: {
      add: "Додати",
      noCode: "немає",
      cols: {
        code: "Код",
        title: "Назва",
        type: "Тип предмета",
        owner: "Чий предмет?",
        place: "Базове розташування",
        createdAt: "Дата створення"
      },
      actions: {
        edit: "Редагувати"
      }
    },
    charactersList: {
      add: "Додати",
      noCode: "немає",
      cols: {
        code: "Код",
        title: "Назва",
        type: "Тип предмета",
        owner: "Чий предмет?",
        location: "Базове розташування",
        createdAt: "Дата створення"
      },
      actions: {
        edit: "Редагувати"
      }
    },
    locationsList: {
      add: "Додати",
      cols: {
        title: "Назва",
        type: "Тип локації",
        createdAt: "Дата створення"
      },
      actions: {
        edit: "Редагувати"
      }
    },
    itemEdit: {
      nameLabel: "Назва предмета",
      photoLabel: "Фото",
      descLabel: "Опис",
      descPlaceholder: "Додайте опис до предмета (необов'язково)",
      typeLabel: "Тип предмета",
      placeLabel: "Базове розташування",
      locationBindLabel: "Прив'язка до локації",
      locationPlaceholder: "Введіть локацію",
      locationNotFound: "Локацію не знайдено",
      ownerLabel: "Належність",
      activeLabel: "Активний?",
      activeDesc: "Предмет можна деактивувати, щоб він ніде не відображався",
      virtualLabel: "Віртуальний?",
      virtualDesc:
        '"Віртуальні" предмети потрібні для складання списку цін, наприклад аптечки',
      gpsLabel: "Розташування",
      addLocation: "Додати розташування",
      addComment: "Додати коментар",
      commentLabel: "Коментар",
      commentPlaceholder: "Додайте коментар до предмета (необов'язково)",
      gpsModalTitle: "Додавання GPS-мітки",
      savedTitle: "Предмет збережено",
      savedCode: 'Код для предмета "{title}" (ID = {id}):'
    },
    locationEdit: {
      nameLabel: "Назва локації",
      photoLabel: "Фото {index}",
      descLabel: "Опис",
      descPlaceholder: "Додайте опис до локації (необов'язково)",
      typeLabel: "Тип локації",
      zoneLabel: "Зона",
      gpsLabel: "Розташування",
      addLocation: "Додати розташування",
      activeLabel: "Активна?",
      activeDesc: "Локацію можна деактивувати, щоб вона ніде не відображалася",
      gpsModalTitle: "Додавання GPS-мітки",
      savedTitle: "Локацію збережено",
      savedBody: 'Локація "{title}" (ID = {id}) успішно збережена'
    },
    characterEdit: {
      nameLabel: "Назва персонажа",
      photoLabel: "Фото",
      descLabel: "Опис",
      descPlaceholder: "Додайте опис до персонажа (необов'язково)",
      addComment: "Додати коментар",
      commentLabel: "Коментар",
      commentPlaceholder: "Додайте коментар до персонажа (необов'язково)",
      savedTitle: "Персонажа збережено",
      savedCode: 'Код для персонажа "{title}" (ID = {id}):'
    }
  },
  enums: {
    common: {
      noCommand: "Поза командою"
    },
    rank: {
      novice: "Новачок",
      experienced: "Досвідчений",
      veteran: "Ветеран",
      master: "Майстер",
      legend: "Легенда"
    },
    pda: {
      own: "Свій",
      rent: "Оренда",
      purchase: "Покупка",
      none: "Немає"
    },
    shotLight: {
      own: "Свій",
      purchase: "Покупка",
      none: "Немає"
    },
    request: {
      approved: "Підтверджено",
      commented: "Залишено коментар",
      declined: "Відхилено",
      partially_paid: "Частково оплачено",
      paid: "Оплачено",
      none: "На розгляді"
    },
    paymentType: {
      cashless: "Безготівково",
      cash: "Готівка",
      combatant: "УБД",
      free: "Безкоштовно",
      none: "Не платив"
    },
    itemType: {
      suit: "Костюм",
      artefact: "Артефакт",
      quest: "Квестовий",
      other: "Інше"
    },
    itemOwner: {
      own: "Клубний",
      personal: "Особистий",
      other: "Чужий/Інше"
    },
    itemPlace: {
      storage: "Склад",
      garage: "Гараж",
      home: "Дім",
      other: "Інше"
    },
    firmwareType: {
      unknown: "Невідомо",
      artefact: "Артефакт",
      soul: 'ПДА "Душа"',
      anomaly: "Аномалія",
      defence: "Незламність"
    },
    locationType: {
      main: "Основна",
      quest: "Квестова",
      other: "Інша"
    },
    locationZone: {
      red: "Червона",
      yellow: "Жовта",
      green: "Зелена",
      blue: "Синя"
    },
    actionType: {
      unknown: "Невідомо",
      legend: "Легенда",
      legend_master: "Ігромайстерська легенда",
      passport_photo: "Фото на паспорт",
      photos: "Фото",
      callsign: "Позивний",
      suit: "Костюм",
      fraction: "Угруповання",
      new_request: "Нова заявка"
    },
    actionMessage: {
      unknown: "Невідомо",
      legend: "Зміни в легенді",
      legend_master: "Ігромайстерська легенда",
      passport_photo: "Змінено фото на паспорт",
      photos: "Змінено фото",
      callsign: "Змінено позивний",
      suit: "Змінено костюм",
      fraction: "Змінено угруповання",
      new_request: "Додано нову заявку"
    }
  },
  nav: {
    profile: "Профіль",
    events: "Події",
    requests: "Заявки",
    members: "Учасники",
    registration: "Реєстрація",
    notifications: "Сповіщення",
    messages: "Повідомлення",
    staff: "Персонал",
    items: "Предмети",
    firmwares: "Прошивки",
    locations: "Локації",
    quests: "Завдання"
  },
  routes: {
    Dashboard: "Панель",
    Profile: "Профіль",
    ProfileEdit: "Редагування профілю",
    ProfileCreate: "Створення персонажа",
    Events: "Події",
    EventMembers: "Учасники",
    AdminRequests: "Заявки",
    AdminMembers: "Учасники",
    AdminRegistration: "Реєстрація",
    AdminStaff: "Персонал",
    AdminNotifications: "Сповіщення",
    AdminMessages: "Повідомлення",
    AdminItems: "Предмети",
    AdminItemEdit: "Редагування предмета",
    AdminFirmwares: "Прошивки",
    AdminFirmwareAdd: "Додавання прошивки",
    AdminLocations: "Локації",
    AdminLocationEdit: "Редагування локації",
    AdminQuests: "Завдання",
    Scan: "Сканування",
    Register: "Реєстрація",
    Login: "Вхід",
    Restore: "Відновлення пароля",
    PassChange: "Зміна пароля"
  },
  errors: {
    api: {
      ERR_SERVICE: "Помилка сервісу",
      ERR_NOT_FOUND: "Не знайдено",
      ERR_ALREADY_EXISTS: "Запис вже існує",
      ERR_ALREADY_ENABLED: "Вже активовано",
      ERR_ALREADY_DISABLED: "Вже деактивовано",
      ERR_BAD_REQUEST: "Некоректний запит",
      ERR_BAD_PARAM: "Некоректний параметр",
      ERR_NOT_ALLOWED: "Дію заборонено",
      ERR_BAD_JWT: "Некоректний JWT-токен",
      ERR_BALANCE_NOT_ENOUGH: "Недостатньо коштів",
      ERR_BAD_AUTH: "Помилка авторизації",
      ERR_BAD_SIGNATURE: "Некоректний підпис"
    },
    bad_param: {
      password: {
        invalid_restore_token: "�������� ����� ���������� ������",
        invalid_current_password: "������� �������� ������"
      }
    },
    not_allowed: {
      request: {
        invalid_check_state: "ĳ� ��������� �������� � ��������� ����� �������� ������"
      },
      member: {
        other_member_editing: "����������� ������ �������� ����������",
        confirmed_request_edit: "����������� ����������� ������ ����������",
        max_user_members_reached: "��������� ����������� ������� ��������� ��� �����������"
      }
    },
    fraction_full: {
      request: {
        members_limit_reached: "� ������� ��������� ��� �������� ��� ��䳿",
        requests_limit_reached: "� ������� ��������� ��� ������ ��� ��䳿"
      }
    },
    service: {
      mail: {
        create_commented_email: "�� ������� ���������� email ��� �������� �� ������",
        create_declined_email: "�� ������� ���������� email ��� ��������� ������"
      }
    }
  }
};

